import { RefundRequest } from "../../../common/types";
import React from "react";
import "./refund-in-days.scss";
import { calcMaxRefundInDays } from "../../../common/models/RefundRequest/maxRefundInDays";

interface RefundInDaysProps {
  refundRequest: RefundRequest;
}

export const RefundInDays: React.FC<RefundInDaysProps> = ({ refundRequest }) => {
  const refundIn = calcMaxRefundInDays(refundRequest);
  const isLate = refundIn && refundIn < 0;

  return <span className={isLate ? "c-refund-in-days__late" : ""}>{refundIn == null ? "--" : refundIn}</span>;
};
